import React, { FC, useState } from 'react'
import t from 'src/translations/main'
import Font from 'src/components/Core/Typography/Font/Font'
import Input from 'src/components/Atoms/Input/Input'
import Button from 'src/components/Atoms/Button/Button'

import {  NewThreadBox, NewThreadButtons, Replies, ThreadBox, Threads } from './OnboardingChatPanel.styles'
import { ChatComment, Comments } from './types'
import { getBaseApiHost } from 'src/components/Core/Utils/url_constants'
import useFetch from 'src/components/Core/Hooks/useFetch/useFetch'
import { GenericCircle } from 'src/components/Molecules/StepProgressBar/StepProgressBar.styles'
import Icon from 'src/components/Core/Iconography/Icon/Icon'
import Flex from 'src/components/Layout/Flex/Flex'

const ChatComments: FC<ChatComment> = props => {
  const [openRepliesId, setOpenReplies] = useState<number | string>()
  const { sendRequest } = useFetch()

  const {
    comments,
    info: {applicationId, step },
    setMessages,
    clearTextInput,
    setOptionsList,
    sendComment
  } = props

  const getInfoForComment = (comment: Comments) => {
    const commentsAmount = comment.childcomments?.length
    let replyButtonInfo = {
      text: 'Reply',
      stateProp: `${comment.commentID}`
    }
    if(commentsAmount > 1){
      replyButtonInfo = {text: `${commentsAmount} Replies`, stateProp: comment.commentID.toString()}
    } else if(commentsAmount === 1) {
      replyButtonInfo = {text: '1 Reply', stateProp: comment.commentID.toString()}
    }
    return {...replyButtonInfo}
  }

  const manageRepliesText = (parentComment: Comments) => {
    const { stateProp } = getInfoForComment(parentComment)
    setOpenReplies(prev => prev === stateProp ? '' : stateProp)
    const unreadCommentsId = comments?.find(comment => comment?.commentID === parseInt(stateProp))
      .childcomments?.filter(childComment => childComment.isCommentRead?.toLowerCase?.() === 'false')
      .map(unreadChildComments => unreadChildComments?.commentID)
    if(unreadCommentsId.length > 0) {
      sendRequest({
        scope: 'onboarding',
        url: import.meta.env.VITE_MOCK_DATA !== 'true'
          ? `${getBaseApiHost()}/Comments/markcommentasread`
          : `${window.location.origin}/mock/postMessage.json`,
        method: 'POST',
        body: {
          applicationID: applicationId,
          commentIds: unreadCommentsId
        }
      },
      data => {
        if(data) {
          setOptionsList(prevList => (
            prevList?.map((obj, index) => {
              if (index === parseInt(step) - 1) {
                obj.unreadCommentsCount = obj.unreadCommentsCount - unreadCommentsId.length
              }
              return obj
            })
          ))
          setMessages(prev => {
            const temp = [...prev]
            const parentCommentIndex = temp.findIndex(comment => comment.commentID === parseInt(stateProp))
            temp[`${parentCommentIndex}`].childcomments.forEach(childComment => {
              if(childComment.isCommentRead.toLowerCase() === 'false'){
                childComment.isCommentRead = 'true'
              }
            })
            return temp
          })
        }
      }
      )
    }
  }

  return (
    <>
      <Threads as={'ul'}  flexDirection='column' maxWidth>
        {
          comments.length > 0
            ? comments.map(parentComment => {
              const isThereChildrenComments = parentComment.childcomments.length > 0
              const isThereUnreadComments = parentComment.childcomments.some(childComment => childComment.isCommentRead?.toLowerCase?.() === 'false')
              return <ThreadBox
                as={'li'}
                key={parentComment.commentID}
                flexDirection='column'
                alignItems='flex-start'
                maxWidth
                chevronUp={openRepliesId === parentComment.commentID.toString()}
              >
                <Font margin='0 0 8px 0' bold>{parentComment.username}</Font>
                <Font margin='0 0 16px 0'>{new Date(parentComment.commentDateTime).toLocaleString()}</Font>
                <Font margin='0 0 24px 0'>{parentComment.commentContent}</Font>
                <Flex onClick={() => manageRepliesText(parentComment)}>
                  {
                    parentComment.childcomments?.length > 0 &&
                    <Icon name={'chevron-down'} size='s' color='dark' />
                  }
                  <Font color='ultraViolet' bold>
                    {getInfoForComment(parentComment)?.text || ''}
                    {isThereUnreadComments && <GenericCircle margin='0 0 5px 2px'/>}
                  </Font>
                </Flex>
                {
                  openRepliesId === parentComment.commentID.toString()
                  && <Replies as='ul' flexDirection='column' zeroReply={!isThereChildrenComments}>
                    {
                      isThereChildrenComments && parentComment.childcomments.map(reply => {
                        return <ThreadBox as={'li'} key={reply.commentID} flexDirection='column' alignItems='flex-start' maxWidth isReply>
                          <Font margin='0 0 4px 0' bold>{reply.username}</Font>
                          <Font margin='0 0 8px 0'>{new Date(reply.commentDateTime).toLocaleString()}</Font>
                          <Font margin='0 0 24px 0'>{reply.commentContent}</Font>
                        </ThreadBox>
                      })
                    }
                    <NewThreadBox flexDirection='column' maxWidth isReply={isThereChildrenComments ? 'nextReply' : 'firstReply'}>
                      <Input placeholder={t('onboarding.chat.newThreadInputTextArea')} isTextarea minHeight='0'/>
                      <NewThreadButtons gap='8px' justifyContent='flex-end' maxWidth>
                        {/* @ts-ignore:next-line */}
                        <Button label={t('onboarding.chat.buttons.clear')} version={2} fontSize='14px' onClick={clearTextInput}/>
                        {/* @ts-ignore:next-line */}
                        <Button label={t('onboarding.chat.buttons.submit')} fontSize='14px' onClick={event => {sendComment(event, parentComment.commentID, true)}}/>
                      </NewThreadButtons>
                    </NewThreadBox>
                  </Replies>
                }
              </ThreadBox>
            })
            : <Font margin='64px 0 0 0'>{t('onboarding.generalMessage.noComments')}</Font>
        }
      </Threads>
    </>
  )
}

export default ChatComments

